/* D-CHISIAMO 18/10/2026. Closing credits: each line fades in once when it enters the screen. Opacity and transform only, so nothing
   else on the page moves. Off with «reduce motion», and without IntersectionObserver every line is simply visible. */
(function () {
  var s = document.querySelector('.bh-q4dc-coda');
  if (!s || !('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var righe = s.querySelectorAll('.bh-q4dc-r, .bh-q4dc-coda__anno');
  var io = new IntersectionObserver(function (voci) {
    voci.forEach(function (v) {
      if (v.isIntersecting) { v.target.classList.add('is-in'); io.unobserve(v.target); }
    });
  }, { rootMargin: '0px 0px -6% 0px' });
  s.classList.add('bh-q4dc-anima');
  righe.forEach(function (r) { io.observe(r); });
})();
